<template>
    <div id="regularPage">
        <div class="title">
            <table>
                <tr>
                    <td class="problem">
                        <label for="">问题：</label>
                    </td>
                    <td>
                        <el-input
                                placeholder="请输入内容"
                                prefix-icon="el-icon-search"
                                v-model="search">
                        </el-input>
                    </td>
                    <td>
                        <el-button type="primary" @click="headerButton(0)">查询</el-button>
                        <el-button type="primary" @click="headerButton(1)">添加</el-button>
                    </td>
                </tr>
            </table>
        </div>
        <div class="table-content">
            <el-table
                    :data="tableData.rows"
                    border
                    style="width: 100%">
                <el-table-column
                        type="index"
                        label="序号"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="问题内容">
                </el-table-column>
                <el-table-column
                        label="选项内容">
                    <template slot-scope="scope">
                        {{scope.row.content.substring(0,scope.row.content.length-1)}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="答案">
                    <template slot-scope="scope">
                        {{scope.row.content.substring(scope.row.content.length-1,scope.row.content.length)}}
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row,0)" type="text" size="small">查看</el-button>
                        <el-button @click="handleClick(scope.row,1)" type="text" size="small">修改</el-button>
                        <el-button @click="handleClick(scope.row,2)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pagesize"
                layout="total, prev, pager, next, jumper"
                :total="totalCount">
        </el-pagination>
        <div class="dialog">
            <el-dialog
                    :title="title1"
                    :visible.sync="dialogVisible"
                    width="45%">
            <span>
               <div class="answer-content">
            <el-container>
                <el-header>
                    <div class="header-answer">
                        问题
                    </div>
                    <div class="header-input">
                        <el-input
                                :disabled="disabled"
                                placeholder="请输入内容"
                                v-model="input1">
                        </el-input>
                    </div>
                </el-header>
                <el-main class="display-flex-auto">
                    <!-- TODO 随机答题盒子 -->
                    <div style="width: 100%">
                        <div>
                            <div class="main-content" v-if="rowId !=='' ">
                                <el-radio-group v-model="radio" @change="change">
                                    <!--匹配正确答案-->
                                    <el-radio v-if="activeIndex === 0 " v-for="(li , index) in radioArr" :key="index"
                                              :disabled="true" :label="li.substring(0,1)">{{li}}</el-radio>
                                    <el-radio v-if="activeIndex !== 0" v-for="(li , index) in radioArr" :key="index"
                                              :disabled="radio ==li.substring(0,1)"
                                              :label="li.substring(0,1)">{{li}}</el-radio>
                                </el-radio-group>
                            </div>
                            <div v-if=" rowId ==='' ">
                              <ul class="addDa">
                                    <li>
                                        <div>
                                            A：
                                        </div>
                                        <div>
                                            <el-input
                                                    placeholder="请输入内容"
                                                    v-model="daan">
                                            </el-input>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            B：
                                        </div>
                                        <div>
                                            <el-input
                                                    placeholder="请输入内容"
                                                    v-model="daan2">
                                              </el-input>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            C：
                                        </div>
                                        <div>
                                            <el-input
                                                    placeholder="请输入内容"
                                                    v-model="daan3">
                                              </el-input>
                                        </div>

                                    </li>
                                    <li>
                                        <div>
                                            D：
                                        </div>
                                        <div>
                                            <el-input
                                                    placeholder="请输入内容"
                                                    v-model="daan4">
                                              </el-input>
                                        </div>
                                    </li>
                              </ul>
                                 <div>
                                     <el-radio-group v-model="radio1">
                                         <el-radio v-for="( li , index ) in radio1Arr" :key="index"
                                                   :label="li"></el-radio>
                                     </el-radio-group>
                                 </div>
                            </div>
                        </div>
                    </div>
                    <!-- TODO 恭喜界面 -->

                </el-main>
            </el-container>
        </div>
            </span>
                <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="handle">确 定</el-button>
            </span>
            </el-dialog>
        </div>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                radio1Arr: ['A', 'B', 'C', 'D'],
                radio1: 'A',

                daan: '',
                daan2: '',
                daan3: '',
                daan4: '',
                buer: "",
                rowId: '',
                //确定标识
                activeIndex: '',
                radioArr: [],
                radio: '',
                disabled: false,
                title1: '',
                totalCount: 0,
                pagesize: 12,
                currentPage: 1,
                dialogVisible: false,
                active: 0,
                query: [],
                search: '',
                input1: '',
                tableData: [{
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }],
                val: '',

            }
        },
        methods: {
            change(val) {

                if (this.activeIndex === 0) {
                    return
                }
                this.val = val
                return (this.radioArr.join(';')) + ';' + val
            },

            //模糊查询 和添加
            headerButton(index) {
                if (index === 0) {
                    //查询
                    this.submit()
                } else {
                    this.disabled = false
                    this.activeIndex = 5
                    this.title1 = '添加问题';
                    this.input1 = ''
                    this.dialogVisible = true
                }
            },
            handle() {
                if (this.activeIndex === 1) {
                    let params = {
                        title: this.input1,
                        content: this.change(this.val),
                        id: this.rowId,
                        type: 2,
                    }
                    this.$axios.get(this.URL.uQuestion.saveUQuestion, {params})
                        .then(res => {
                            if (res.status === 200) {
                                this.$message({
                                    message: '修改问题成功',
                                    type: 'success'
                                });
                                this.dialogVisible = false;
                                this.submit()
                            } else {
                                this.$message.error('服务器错误，请稍后再试');
                            }
                        })
                } else if (this.activeIndex === 5) {
                    let params = {
                        title: this.input1,
                        content: 'A' + '.' + this.daan + ';' + 'B' + '.' + this.daan2 + ';' + 'C' + '.' + this.daan3 + ';' + 'D' + '.' + this.daan4 + ';' + this.radio1,
                        type: 2,
                    }
                    this.$axios.get(this.URL.uQuestion.saveUQuestion, {params})
                        .then(res => {
                            if (res.status === 200) {
                                this.$message({
                                    message: '修改问题成功',
                                    type: 'success'
                                });
                                this.dialogVisible = false;
                                this.submit()
                            } else {
                                this.$message.error('服务器错误，请稍后再试');
                            }
                        })
                } else {
                    this.dialogVisible = false

                }

            },
            //列表查询接口
            submit() {
                let params = {
                    page: this.currentPage,
                    size: this.pagesize,
                    questionStr: this.search,
                    type: 2,
                }
                this.$axios.get(this.URL.uQuestion.backList, {params}).then(res => {
                    if (res.status === 200) {
                        this.totalCount = res.data.count
                        this.tableData = res.data
                    }
                })
            },

            //翻页
            handleCurrentChange(val) {
                this.currentPage = val
                this.submit()
            },
            //查看 删除 修改
            handleClick(row, index) {
                this.rowId = row.id
                console.log(this.rowId);
                this.activeIndex = index
                //正确答案
                this.radio = row.content.substring(row.content.length - 1, row.content.length)
                //循环数组
                this.radioArr = (row.content.substring(0, row.content.length - 2)).split(';')
                if (index === 0) {
                    //查看
                    this.dialogVisible = true
                    this.input1 = row.title
                    this.disabled = true
                    this.title1 = '查看问题'
                } else if (index === 1) {
                    //修改
                    this.dialogVisible = true
                    this.input1 = row.title
                    this.title1 = '修改问题'
                    this.disabled = false

                } else {
                    //删除
                    let params = {
                        id: this.rowId
                    }
                    this.$axios.get(this.URL.uQuestion.deluQuestion, {params})
                        .then(res => {
                            if (res.status === 200) {
                                this.$message({
                                    message: '删除问题成功',
                                    type: 'success'
                                });
                                this.submit()
                            } else {
                                this.$message.error('服务器错误，请稍后再试');
                            }
                        })

                }
            },
            //获取18个随机按钮
            getQuery() {
                this.$axios.get(this.URL.uQuestion.getUQuestionListForEighteen).then(res => {
                    const result = res.data;
                    //修改数据
                    result.map(el => {
                        let newContent = el.content.split(";")
                        el.content = newContent
                    });
                    this.query = result
                })
            }
        },
        computed: {},
        created() {
            this.submit()
            this.getQuery()
        },
        watch: {
            dialogVisible(val) {
                if (!val) {
                    this.rowId = ''

                }

            },

        }

    }
</script>

<style lang="less" scoped>
    #regularPage {
        margin-top: 20px;
    }

    .title {
        position: relative;
    }

    .title table tr:first-child {
        margin-bottom: 20px;
    }

    .title table tr:first-child td {
        height: 40px;
        line-height: 40px;
        margin-right: 60px;
    }

    .title table tr:first-child td:last-child {
        position: absolute;
        right: 0;
    }

    .title table tr td label {
        width: 60px;
        font-size: 16px;
    }

    .problem {
        color: #606266;
        padding: 0 10px;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        display: flex;
    }

    .table-content {
        margin-top: 10px;
    }

    .answer-content {
        margin-top: 10px;
        border: 1px solid #ebeef5;
        .el-header {
            margin-top: 15px;
            display: flex;
            .header-input {
                margin-left: 5%;
                width: 80%;
                /deep/ .el-input__inner {
                    height: 60px !important;
                }
            }
            .header-answer {
                border: 1px solid #ebeef5;
                border-radius: 4px;
                width: 15%;
                text-align: center;
                padding: 18px;
                box-sizing: border-box;
            }
        }
        .main-content {
            border: 1px solid #ebeef5;
            position: relative;
            box-sizing: border-box;
            height: 280px;
            .el-radio-group {
                display: '' !important;
            }
            .el-radio {
                margin-left: 7% !important;
                margin-top: 50px !important;
                width: 35% !important;
            }
            .wen-box {
                margin-top: 45px;
                word-break: break-all;
                word-wrap: break-word;
                font-size: 18px;
                font-weight: 600;
                color: #606266;
                text-align: center;
                width: 100%;
                height: 40px;
            }
            .check-box {
                margin: 0 auto;
                div {
                    cursor: pointer;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-left: 30px;
                    margin-top: 10px;
                    text-align: left;
                    line-height: 58px;
                    font-size: 18px;
                    font-weight: 600;
                    color: #606266;
                    float: left;
                    background-size: cover;
                    width: 300px;
                    height: 58px;
                }
            }
            .submit {
                position: absolute;
                height: 40px;
                bottom: 80px;
                left: 50%;
                margin-left: -35px;
            }
        }
    }

    .addDa {
        li {
            display: flex;
            margin: 20px;
            align-items: center;

        }
        .el-radio-group {
            margin-left: 10px;
        }
    }


</style>



// WEBPACK FOOTER //
// src/views/audit/regular/audit-regular.vue